import { render } from "./copyMediaAccountModal.vue?vue&type=template&id=0567329c"
import script from "./copyMediaAccountModal.vue?vue&type=script&lang=js"
export * from "./copyMediaAccountModal.vue?vue&type=script&lang=js"

import "./copyMediaAccountModal.vue?vue&type=style&index=0&id=0567329c&lang=less"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__